import { SettingsLayout } from "@/components/layout/SettingsLayout";
import { CategoryList } from "@/components/matrix/CategoryList";

export function CategoriesPage() {
  return (
    <SettingsLayout>
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold">Scoring Categories</h2>
          <p className="text-muted-foreground">
            Manage scoring categories parsed from the Master Matrix.
          </p>
        </div>
        <CategoryList />
      </div>
    </SettingsLayout>
  );
}
